import EmailNotificationsPage from './email-notifications-page';

export default EmailNotificationsPage;


// WEBPACK FOOTER //
// ./src/features/organization/pages/email-notifications/index.js